class Shikigawara {
    constructor() {
        $(()=>{
            this.initSlide();
        })


    }

    initSlide(){
        this.slide = $("#prg-variation-list");
        this.slide.slick({
            centerMode: true,
            centerPadding: '18%',
            asNavFor: '#prg-variation-thumb',
            arrows: true,
            responsive: [{

                breakpoint: 768,
                settings: {
                    centerPadding: '10%',
                }

            }]
        });
        $("#prg-variation-thumb").slick({
            slidesToShow: 1,
            fade: true,
            arrows: false,
        })
        this.slide.on("beforeChange",()=>{
            this.slide.addClass("is-transition");
        }).on("afterChange",()=>{
            this.slide.removeClass("is-transition");
        })

        $(".prg-process-slide").slick({
            autoplay: true,
            autoplaySpeed: 1000,
            speed: 200,
            fade: true,
            swipe: false,
            arrows: false,
            pauseOnFocus: false,
            pauseOnHover: false,
        })
    }

}

var _shikigawara = new Shikigawara();